import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { setupGlobalHandlers, logError } from './services/errorBoundary';

const app = createApp(App);

app.config.errorHandler = (error, instance, info) => {
  logError(error, {
    type: 'vue_error_handler',
    componentName: instance?.$options?.name || 'Unknown',
    componentInfo: info,
    propsData: instance?.$props,
    route: router.currentRoute.value
  });

  if (process.env.NODE_ENV === 'development') {
    console.error('Vue Error Handler:', error, instance, info);
  }
};

app.config.warnHandler = (msg, instance, trace) => {
  if (process.env.NODE_ENV === 'development') {
    logError(new Error(`Vue Warning: ${msg}`), {
      type: 'vue_warning',
      componentName: instance?.$options?.name || 'Unknown',
      trace,
      route: router.currentRoute.value
    });
  }
};

setupGlobalHandlers();

app.use(store);
app.use(router);

app.mount('#app');